import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const LOGO = "/sito/img/logo.png";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (ready && user) nav("/admin/dashboard");
  }, [ready, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin/dashboard");
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Accesso non riuscito. Riprova.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="adm">
      <div className="adm-login">
        <div className="adm-login-card">
          <img src={LOGO} alt="POWERCOM" />
          <h1>Area riservata</h1>
          <p className="sub">Accedi per gestire i contenuti del sito.</p>
          <form onSubmit={submit}>
            <div className="adm-field">
              <label>Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="admin@powercom.it" data-testid="admin-email" />
            </div>
            <div className="adm-field">
              <label>Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" data-testid="admin-password" />
            </div>
            <button className="adm-btn full" disabled={busy} data-testid="admin-login-btn">
              {busy ? "Accesso…" : "Accedi"}
            </button>
            {err && <p className="adm-err" data-testid="admin-login-err">{err}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}
